export const useGalleryPreview = () => {
  const aspectRatio = {
    onePreview: 1.559,
    threePreviewsList: [1.086, 0.926, 0.926]
  }
  const roundedPreviews = [
    'rounded-r-none',
    'rounded-l-none  rounded-b-none',
    'rounded-t-none rounded-l-none'
  ]

  return {
    aspectRatio,
    roundedPreviews
  }
}
